﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import TypeOfClaim from "./Registration/TypeOfClaim.svelte";
import LivingClaimants from "./Registration/LivingClaimants.svelte";
import SpouseChildClaimants from "./Registration/SpouseChildClaimants.svelte";
import ClaimantsId from "./Registration/ClaimantsId.svelte";
import BankDetails from "./Registration/BankDetails.svelte";
import AdditionalInfo from "./Registration/AdditionalInfo.svelte";
import DocumentUpload from "./Registration/DocumentUpload.svelte";
import Confirmation from "./Registration/Confirmation.svelte";
import Review from "./Registration/Review.svelte";
import ThankYou from "./Registration/ThankYou.svelte";
import SaveAndCloseThankYou from "./Registration/SaveAndCloseThankYou.svelte";
import Verify from "./Registration/Verify.svelte";
import NextRegistrationDetails from "./Registration/NextRegistrationDetails.svelte";

import FileUploadLandingPage from "./FileUpload/LandingPage.svelte";
import FileUploadDocumentUpload from "./FileUpload/DocumentUpload.svelte";
import FileUploadThankYou from "./FileUpload/ThankYou.svelte";

import ReviewAndSignLandingPage from "./ReviewAndSign/LandingPage.svelte";
import ReviewAndSignConfirmationSignature from "./ReviewAndSign/ConfirmationSignature.svelte";
import ReviewAndSignThankYou from "./ReviewAndSign/ThankYou.svelte";

import Error from "./Error.svelte";

import { projectSettings } from '../config';

export const registrationPageList = [
    {
        pageIndex: 0,
        component: LandingPage,
        title: "",
        showInTracker: true,
        routeId: "/Registration",
        nextPage: "/Registration/PersonalDetails",
        properties: {
            pageTitle: `${projectSettings.classActionName}`,
            lastVisitedPage: "Landing Page",
        },
    },
    {
        pageIndex: 1,
        component: PersonalDetails,
        title: "Personal Details",
        showInTracker: true,
        routeId: "/Registration/PersonalDetails",
        nextPage: (model) => model.confirmationPage ? "/Registration/Confirmation" : "/Registration/TypeOfClaim",
        previousPage: "/Registration",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Personal Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Personal Details",
        },
    },
    {
        pageIndex: 2,
        component: TypeOfClaim,
        title: "Type of Claim",
        showInTracker: true,
        routeId: "/Registration/TypeOfClaim",
        nextPage: (model) => {
            if (model.confirmationPage) {
                return "/Registration/Confirmation";
            }

            if (model.claimDetail.claimType === "My own claim") {
                return "/Registration/LivingClaimants";
            }

            return "/Registration/SpouseChildClaimants";
        },
        previousPage: "/Registration/PersonalDetails",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Type of Claim`,
            persistUrl: "/api/project",
            lastVisitedPage: "Type of Claim",
        },
    },
    {
        pageIndex: 3,
        component: LivingClaimants,
        title: "Living Claimants",
        showInTracker: true,
        routeId: "/Registration/LivingClaimants",
        nextPage: (model) => model.confirmationPage ? "/Registration/Confirmation" : "/Registration/ClaimantsId",
        previousPage: "/Registration/TypeOfClaim",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Living Claimants`,
            persistUrl: "/api/project",
            lastVisitedPage: "Living Claimants",
        },
    },
    {
        pageIndex: 4,
        component: SpouseChildClaimants,
        title: "Spouse or Child Claimants",
        showInTracker: true,
        routeId: "/Registration/SpouseChildClaimants",
        nextPage: (model) => model.confirmationPage ? "/Registration/Confirmation" : "/Registration/ClaimantsId",
        previousPage: "/Registration/TypeOfClaim",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Spouse or Child Claimants`,
            persistUrl: "/api/project",
            lastVisitedPage: "Spouse or Child Claimants",
        },
    },
    {
        pageIndex: 5,
        component: ClaimantsId,
        title: "Claimants Id",
        showInTracker: true,
        routeId: "/Registration/ClaimantsId",
        nextPage: (model) => model.confirmationPage ? "/Registration/Confirmation" : "/Registration/BankDetails",
        previousPage: (model) => {
            if (model.claimDetail.claimType === "My own claim") {
                return "/Registration/LivingClaimants";
            }

            return "/Registration/SpouseChildClaimants";
        },
        properties: {
            pageTitle: `${projectSettings.classActionName} - Claimants Id`,
            persistUrl: "/api/project",
            lastVisitedPage: "Claimants Id",
        },
    },
    {
        pageIndex: 6,
        component: BankDetails,
        title: "Bank Details",
        showInTracker: true,
        routeId: "/Registration/BankDetails",
        previousPage: "/Registration/ClaimantsId",
        nextPage: "/Registration/AdditionalInfo",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Bank Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Bank Details",
        },
    },
    {
        pageIndex: 7,
        component: AdditionalInfo,
        title: "Additional Information",
        showInTracker: true,
        routeId: "/Registration/AdditionalInfo",
        nextPage: "/Registration/Confirmation",
        previousPage: "/Registration/BankDetails",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Additional Information`,
            persistUrl: "/api/project",
            lastVisitedPage: "Additional Information",
        },
    },
    {
        pageIndex: 8,
        component: Confirmation,
        title: "Confirmation",
        showInTracker: true,
        routeId: "/Registration/Confirmation",
        previousPage: "/Registration/AdditionalInfo",
        nextPage: "/Registration/ThankYou",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Confirmation`,
            nextPageLabel: "Confirm and register",
            persistUrl: `/api/registration?timezoneOffset=${(-1 * (new Date().getTimezoneOffset()))}`,
            lastVisitedPage: "Confirmation",
        },
    },
    {
        pageIndex: 9,
        component: ThankYou,
        title: "Registration Submitted",
        showInTracker: false,
        routeId: "/Registration/ThankYou",
        nextPage: "/Registration/NextRegistrationDetails",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Thank you`,
        },
    },
    {
        pageIndex: 10,
        component: NextRegistrationDetails,
        title: "Next Registration Details",
        showInTracker: false,
        routeId: "/Registration/NextRegistrationDetails",
        nextPage: "/Registration/TypeOfClaim",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Next Registration`,
            persistUrl: "/api/project",
            lastVisitedPage: "Next Registration",
        },
    },
    {
        pageIndex: 11,
        component: SaveAndCloseThankYou,
        title: "Registration Saved",
        showInTracker: false,
        routeId: "/Registration/SaveAndClose",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Thank you`,
        },
    },
    {
        pageIndex: 12,
        component: Review,
        title: "Review",
        showInTracker: false,
        routeId: "/Review",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Review`,
        },
    },
    {
        pageIndex: 13,
        component: Verify,
        title: "",
        showInTracker: false,
        routeId: "/Verify",
        nextPage: "/Registration/PersonalDetails",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Verify`,
        },
    },
    {
        pageIndex: 14,
        component: Error,
        title: "Error",
        showInTracker: false,
        routeId: "*/Error",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Error`,
        },
    },
];

export const documentUploadPageList = [
    {
        pageIndex: 0,
        component: FileUploadLandingPage,
        title: "Document Upload Form",
        showInTracker: true,
        routeId: "/FileUpload",
        nextPage: "/FileUpload/DocumentUpload",
        properties: {
            pageTitle: `${projectSettings.classActionName}`,
        },
    },
    {
        pageIndex: 1,
        component: FileUploadDocumentUpload,
        title: "Document Upload",
        showInTracker: true,
        routeId: "/FileUpload/DocumentUpload",
        nextPage: "/FileUpload/ThankYou",
        previousPage: "/FileUpload",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Document Upload`,
            persistUrl: `/api/file-upload-submit`,
        },
    },
    {
        pageIndex: 2,
        component: FileUploadThankYou,
        title: "Document Upload Submitted",
        showInTracker: false,
        routeId: "/FileUpload/ThankYou",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Thank you`,
        },
    },
];


export const reviewAndSignPageList = [
    {
        pageIndex: 0,
        component: ReviewAndSignLandingPage,
        title: "Registration Review",
        showInTracker: true,
        routeId: "/ReviewAndSign",
        nextPage: "/ReviewAndSign/ConfirmationSignature",
        properties: {
            pageTitle: `${projectSettings.classActionName}`,
        },
    },
    {
        pageIndex: 1,
        component: ReviewAndSignConfirmationSignature,
        title: "Confirmation and Signature",
        showInTracker: true,
        routeId: "/ReviewAndSign/ConfirmationSignature",
        nextPage: "/ReviewAndSign/ThankYou",
        previousPage: "/ReviewAndSign",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Confirmation and Signature`,
            persistUrl: `/api/confirm-signature`,
        },
    },
    {
        pageIndex: 2,
        component: ReviewAndSignThankYou,
        title: "Confirmation Review and Signature Submitted",
        showInTracker: false,
        routeId: "/ReviewAndSign/ThankYou",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Thank you`,
        },
    },
];



